export const TenantList = [
  {
    tenantCodes: ['cargilltest', 'cargillprod'],
    displayName: 'Cargill',
    customerCode: 'cgl60',
  },
  {
    tenantCodes: ['averitttest', 'averittprod'],
    displayName: 'Averitt Express, Inc',
    customerCode: 'ave4u',
  },
  {
    tenantCodes: ['cattest', 'catprod'],
    displayName: 'CAT',
    customerCode: 'cat7x',
  },
  {
    tenantCodes: ['chstest', 'chsprod'],
    displayName: 'CHS',
    customerCode: 'chs9l',
  },
  {
    tenantCodes: ['covenanttest', 'covenantprod'],
    displayName: 'Covenant Logistics',
    customerCode: 'co2yt',
  },
  {
    tenantCodes: ['dollargeneraltest', 'dollargeneralprod'],
    displayName: 'Dollar General',
    customerCode: 'dg3nl',
  },
  {
    tenantCodes: ['evanstest', 'evansprod'],
    displayName: 'Evans Transportation',
    customerCode: 'eva9o',
  },
  {
    tenantCodes: ['kdptest', 'kdpprod'],
    displayName: 'Keurig Dr. Pepper',
    customerCode: 'kdp5t',
  },
  {
    tenantCodes: ['td100test'],
    displayName: 'Mastery Logistics',
    customerCode: 'td100',
  },
  {
    tenantCodes: ['mm100dev'],
    displayName: 'Mastery Logistics',
    customerCode: 'mm100',
  },
  {
    tenantCodes: ['mm100test'],
    displayName: 'Mastery Logistics',
    customerCode: 'mm100',
  },
  {
    tenantCodes: ['tangotest'],
    displayName: 'Mastery Logistics',
    customerCode: 'mit01',
  },
  {
    tenantCodes: ['demoprod'],
    displayName: 'Mastery Logistics',
    customerCode: 'mdem0',
  },
  {
    tenantCodes: ['ml100test', 'ml100prod'],
    displayName: 'MoLo Solutions',
    customerCode: 'ml100',
  },
  {
    tenantCodes: ['pepsitest', 'pepsiprod'],
    displayName: 'Pepsi',
    customerCode: 'pep5c',
  },
  {
    tenantCodes: ['pr100test', 'pr100prod'],
    displayName: 'Prime',
    customerCode: 'pr100',
  },
  {
    tenantCodes: ['ru100test', 'ru100prod'],
    displayName: 'Ruan',
    customerCode: 'ru100',
  },
  {
    tenantCodes: ['sn100dev'],
    displayName: 'Schneider National',
    customerCode: 'sn100',
  },
  {
    tenantCodes: ['sn100test', 'sn100prod'],
    displayName: 'Schneider National',
    customerCode: 'sn100',
  },
  {
    tenantCodes: ['tm100test', 'tm100prod'],
    displayName: 'TMC Transportation',
    customerCode: 'tm100',
    redirectEmail: 'Notifications-TMC-Test@mastery.net',
  },
  {
    tenantCodes: ['usmmgtest', 'usmmgprod'],
    displayName: 'U.S. Multimodal Group',
    customerCode: 'usmmg',
  },
  {
    tenantCodes: ['we100test', 'we100prod'],
    displayName: 'Werner Enterprises',
    customerCode: 'we100',
  },
  {
    tenantCodes: ['bisontest', 'bisonprod'],
    displayName: 'Bison',
    customerCode: 'bi50n',
  },
  {
    tenantCodes: ['cranetest', 'craneprod'],
    displayName: 'Crane',
    customerCode: 'cra73',
  },
  {
    tenantCodes: ['redclassictest', 'redclassicprod'],
    displayName: 'Red Classic',
    customerCode: 'rcl82',
  },
  {
    tenantCodes: ['hubdev', 'hubtest', 'hubuat-e', 'hubuat-c', 'hubprod'],
    displayName: 'Mastery Logistics',
    customerCode: 'hub',
  },
];
